'use strict';

var jsonDiffPatch = require('jsondiffpatch');
var initialState = {
    stateHistory: {
        history: [],
        timestamps: [],
        actions: [],
        current: -1
    }
};
function calculateDiff(lhs, rhs) {
    var removeKeys = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    var lhsClone = Object.assign({}, lhs);
    var rhsClone = Object.assign({}, rhs);
    removeKeys.forEach(function (key) {
        delete lhsClone[key];delete rhsClone[key];
    });
    return jsonDiffPatch.diff(lhsClone, rhsClone);
}
/**
 * Store enhancer that adds state history (stored within the state)
 */
var trackHistoryStoreEnhancer = function trackHistoryStoreEnhancer() {
    var hydratingState = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
    return function (createStore) {
        return function (reducer) {
            var state = arguments.length <= 1 || arguments[1] === undefined ? hydratingState : arguments[1];
            return createStore(trackReducerChanges(reducer, state));
        };
    };
};
/**
 * Higher-order reducer-wrapper to log all state changes generated by said reducer
 *
 * TODO: When hydrateState is passed, we replace the history state by the given one after the first reducer has run
 */
function trackReducerChanges(reducer) {
    var hydrateState = arguments.length <= 1 || arguments[1] === undefined ? initialState : arguments[1];

    return function (state, action) {
        if (state === undefined) state = hydrateState;

        // Compute new state after applying reducer
        var newAppState = reducer(state, action);
        // Nothing to do if the two states match (by reference)
        if (state === newAppState) {
            return newAppState;
        }
        // Do nothing if the action has special flagged (used by debug tools)
        // Instead of this we could compare to see if the state is unchanged on the non-tracking part, but this might be too expensive
        if (action.meta === 'SKIP_HISTORY_TRACKING') {
            return newAppState;
        }
        // Calculate the delta of the state (ignoring the stateHistory key)
        var delta = calculateDiff(state, newAppState, ['stateHistory']);
        // Do nothing if delta is null
        if (typeof delta === 'undefined') {
            return newAppState;
        }
        // Update the newAppState
        // Note: The only way to do this properly is to use an immutable library like ImmutableJS that will do a complete recursive deep
        //       cloning of the history field. However, for our purposes as long as we shallow clone history we are fine because nothing
        //       will write to its subproperties
        var clonedState = Object.assign({}, newAppState, {
            stateHistory: Object.assign({}, newAppState.stateHistory, {
                history: Object.assign([], newAppState.stateHistory.history),
                timestamps: Object.assign([], newAppState.stateHistory.timestamps),
                actions: Object.assign([], newAppState.stateHistory.actions),
                current: newAppState.stateHistory.current
            })
        });
        clonedState.stateHistory.history.push(delta);
        clonedState.stateHistory.timestamps.push(Date.now());
        clonedState.stateHistory.actions.push(action.type);
        clonedState.stateHistory.current++;
        return clonedState;
    };
}
exports['default'] = trackHistoryStoreEnhancer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-state-history/lib/Middleware.js
 ** module id = 1701
 ** module chunks = 0
 **/